import { BaseProps } from '@/atoms/forms/types';
import { TextareaHTMLAttributes } from 'react';

export enum TEXT_AREA_VARIANTS {
  DEFAULT = 'default',
  INPUT_STYLE = 'input_style',
}

export type TextAreaProps = BaseProps &
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    variant?: TEXT_AREA_VARIANTS;
  };

export type HTMLTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  isInvalid: boolean;
  variant?: TEXT_AREA_VARIANTS;
};
